import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from '../../AuthContext';
import axiosInstance from "../../axiosInstance";
import StudentModel from "../modal/TeacherModal";
import { Button } from "@mui/material";
import './student.css';
import MUIDataTable from "mui-datatables";
import Loader from "../Loader";
import TablePagination from '@mui/material/TablePagination';




const Student = () => {
  const { user } = useAuth();
  const [data, setData] = useState([])
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState('View');
  const [studentDetail, setStudentDetail] = useState([])
  const [tempTeachers, setTempTeachers] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const { loading, showLoader, hideLoader } = useLoader();
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false)
  const [studentCount,setStudentCount] = useState(0);



  const closeAddModal = () => {
    setIsOpen(false)
    setMode("View")
  }

  const handleDownloadExcel = async () => {
    try {
      setLoading(true);
      
      // STEP 1: Download the Excel file
      const response = await axiosInstance.get('/api/student/export/excel', {
        responseType: 'blob',
      });

      // Create a blob from the Excel data
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const today = new Date().toISOString().split('T')[0];
      link.download = `Students_Data_${today}.xlsx`;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // STEP 2: Auto-distribute remaining physical certificates
      try {
        const distributeRes = await axiosInstance.post('/api/student/distributeRemaining');
        alert('✅ Excel downloaded successfully!\n\n' + distributeRes.data);
      } catch (distributeError) {
        console.error('Error auto-distributing:', distributeError);
        alert('✅ Excel downloaded, but failed to update distribution status: ' + 
              (distributeError.response?.data || distributeError.message));
      }

      // Refresh data to reflect changes
      fetchStudent();
      
    } catch (error) {
      console.error('Error downloading Excel:', error);
      alert('❌ Failed to download Excel: ' + (error.response?.data || error.message));
    } finally {
      setLoading(false);
    }
  };


  const fetchStudent = () => {

    //showLoader()
    if (user.role === 'TEACHER') {
      setLoading(true);

      axiosInstance.get(`/api/student/teacher/${user.id}/students?search=${searchText}&page=${page}&size=${rowsPerPage}`).then((res) => {
        setData(res.data.content)
        setOriginalData(res.data.content)
        //setFilteredData(res.data)
        //  hideLoader()

      }).catch((res) => {

        console.log(res)
      }).finally(()=>{
        setLoading(false);

      })

    } else {
      // axiosInstance.get(`/api/student/getAll?page=${page}&size=${rowsPerPage}`).then((res)=>{
      //     console.log(res.data.content,'slice')

      //     setData(res.data.content)
      //     // setFilteredData((res.data.content))
      //     setOriginalData(res.data.content)
      //     hideLoader()

      // }).catch((err)=>{
      //     console.error(err)

      // })

      setLoading(true);

      axiosInstance.get(`/api/student/getAlls?page=${page}&size=${rowsPerPage}&search=${searchText}`).then((res) => {
        console.log(res.data.content, 'slice')

        setData(res.data.content)
        // setFilteredData((res.data.content))
        setOriginalData(res.data.content)

      }).catch((err) => {
        console.error(err)

      }).finally(()=>{
        setLoading(false)
      })

      axiosInstance.get(`/getAllteacher`).then((res) => {
        setTempTeachers(res.data)

      }).catch((err) => {
        console.error(err)

      })
    }

  }

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }



  const debouncedSearch = useCallback(
    debounce((val) => {
      setSearchText(val || '');
      setPage(0); // reset to page 0
    }, 1000),
    []
  );

  useEffect(() => {
    if (user.id === '') {
      return;
    }
    fetchStudent();

  }, [user, totalCount,page, rowsPerPage, searchText])

  useEffect(()=>{
    setStudentCount(data.length);

  },[data])

  // useEffect(() => {
  //   if (user.id !== '') {


  //     setLoading(true);
  //     axiosInstance.get(`/api/student/getAlls?page=${page}&size=${rowsPerPage}&search=${searchText}`).then((res) => {
  //       console.log(res.data.content, 'slice')

  //       setData(res.data.content)
  //       // setFilteredData((res.data.content))
  //       setOriginalData(res.data.content)
  //       // hideLoader()

  //     }).catch((err) => {
  //       console.error(err)

  //     }).finally(() => {
  //       setLoading(false)
  //     })

  //     axiosInstance.get(`/getAllteacher`).then((res) => {
  //       setTempTeachers(res.data)

  //     }).catch((err) => {
  //       console.error(err)

  //     })
  //   }



  // }, [page, rowsPerPage, searchText])


 useEffect(() => {
   console.log(user,"user");
  if (!user?.id) return;

  const encodedSearch = encodeURIComponent(searchText || '');
  console.log(user,"user");

  axiosInstance
    .get(`/api/student/totalCount?teacherId=${user.id}&searchText=${encodedSearch}`)
    .then((res) => {
      setTotalCount(res.data);
    })
    .catch((err) => {
      console.error("Failed to fetch total count:", err);
    });
}, [user?.id, searchText]);


  const getStudentDetail = (student) => {

    axiosInstance.get(`/api/student/detail/${student[0]}`).then((res) => {

      setStudentDetail(res.data)
      console.log(res.data,"resData")
      setIsOpen(true)
      setMode('View')

    }).catch(() => {

    })

  }


  const options = {


    serverSide: true,
    rowsPerPage: rowsPerPage,
    count: totalCount,
    page: page,
    sort:false,
    selectableRows: "none",
    responsive: "standard",
    onTableChange: (action, state) => {
      if (action === 'changePage') {
        setPage(state.page)
        setRowsPerPage(state.rowsPerPage)

      }
      if (action === 'changeRowsPerPage') {
        setPage(0)
        setRowsPerPage(state.rowsPerPage)

      }


    },
    onSearchChange: (val) => {
      console.log(val, "value")
      debouncedSearch(val);

    },
    // onTableChange: (action, tableState) => {
    //   if (action === "search") {

    //     setFilteredData(tableState.displayData);
    //     //  setTotalCount(tableState.displayData.length)
    //     // setPage(0);
    //   }

    //   if (action === "changePage") {
    //     setPage(tableState.page);
    //   }

    //   if (action === "changeRowsPerPage") {
    //     setRowsPerPage(tableState.rowsPerPage);
    //     setPage(0);
    //   }
    // }

    customFooter: () => null,
    download: true,

    onRowClick: (rowData, rowMeta) => {
      console.log('Row clicked:', rowMeta);
      getStudentDetail(rowData);
    },
    onDownload: (buildHead, buildBody, columns, data) => {
    

      const excludeCols = ['id'];
      const visibleColumns = columns.filter(col => !excludeCols.includes(col.name));

      // Add "Sr No" as first column
      const finalColumns = [
        { name: 'srNo', label: 'Sr No' },
        ...visibleColumns,
      ];

      const searchParam = searchText ? `search=${encodeURIComponent(searchText)}` : "";


      if(user.role === 'TEACHER'){
        axiosInstance.get(`/api/student/downloadForTeacher?teacherId=${user.id}&searchText=${searchText}`).then((res)=>{

          const fullData = res.data.content;
              const csvData = fullData.map((row, index) => ({
            data: [
              
              ...visibleColumns.map(col => row[col.name] ?? ''),
            ],
          }));
           const csv = buildHead(finalColumns) + buildBody(csvData);
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "students.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);


        }).catch(()=>{

        })

      }else{
         axiosInstance.get(`/api/student/downloadAll?${searchParam}`)
        .then(res => {
          const fullData = res.data.content; 

          const csvData = fullData.map((row, index) => ({
            data: [
              
              ...visibleColumns.map(col => row[col.name] ?? ''),
            ],
          }));

          const csv = buildHead(finalColumns) + buildBody(csvData);
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "students.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });

      }

     




      return false; // prevent

  
    }





  };


  const columns = [
    {
      name: "id",
      label: "Id",
      options: { display: 'excluded' }
    },
       {
      name: "srNo",
      label: "srNo",
      options: { display: 'excluded' }
    },

   
    {
      name: "regId",
      label: "RegId",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "name",
      label: "NAME",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "teacher",
      label: "TEACHER",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "birthDate",
      label: "BirthDate",
      options: {
        display: false,
        download: true
      }
    },
    {
      name: "level",
      label: "Level",
      options: {
        display: false,
        download: true
      }
    },
    {
      name: "l0",
      label: "l0",
      options: { display: 'excluded' }
    },
     {
      name: "l1",
      label: "l1",
      options: { display: 'excluded' }
    },
     {
      name: "l2",
      label: "l2",
      options: { display: 'excluded' }
    },
     {
      name: "l3",
      label: "l3",
      options: { display: 'excluded' }
    },
     {
      name: "l4",
      label: "l4",
      options: { display: 'excluded' }
    },
    {
      name: "l5",
      label: "l5",
      options: { display: 'excluded' }
    },
    {
      name: "l6",
      label: "l6",
      options: { display: 'excluded' }
    },
    {
      name: "l7",
      label: "l7",
      options: { display: 'excluded' }
    },
    {
      name: "l8",
      label: "l8",
      options: { display: 'excluded' }
    }
  ];



  


  return (

    <div className="student-container">
      {loading && <Loader />}

      <div className="componet_header">
        <div className="Header">

          STUDENT

        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          {user.role !== 'TEACHER' && (
            <Button 
              className="mui-button" 
              onClick={handleDownloadExcel}
              disabled={loading}
              style={{ backgroundColor: '#4caf50', color: 'white' }}
            >
              {loading ? '⏳ Processing...' : '📊 Download Excel'}
            </Button>
          )}
          <Button className="mui-button" onClick={() => { setMode("Add"); setIsOpen(true); }}>
            Add New
          </Button>

        </div>

      </div>
      <div className="table-wrapper"  >
        <div className="teacher-header" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>

           <span>Total Students :{totalCount}</span>
          <TablePagination

            component="div"
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage)
            }}

            count={totalCount}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[100, 500, 1000]}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}

          />
        </div>
       


        <MUIDataTable
          data={data}
          columns={columns}
          options={options}

        />


      </div>

      {isOpen && (
        <StudentModel
          closeAddModal={closeAddModal}
          data={studentDetail}
          setIsOpen={setIsOpen}
          open={isOpen}
          mode={mode}
          teachers={tempTeachers}
        />
      )}
    </div>



  )

}




export default Student;